<template>
    <div>
        <div id="map"></div>
        <div class="zoom-tip" :style="toolBarStyle1">当前层级: {{ currentZoom }}</div>
        <Selector :selected="selected" @change="onChange" @sidebar-toggle="handleSidebarToggle" />
        <ToolBar class="tool-bar" :pathForAcross="pathForAcross" @openArea="areaVisible = true" :style="toolBarStyle" />
        <AreaWindow v-if="areaVisible" @cancel="cancel" @clear="clear" @query="query" :overlays="overlays" :mouseTool="mouseTool" />
        <div class="amap-ctrl-list-layer amap-ctrl-list-layer2">
            <ul class="amap-ctrl-base-layer">
                <li class="amap-ui-ctrl-layer-base-item">
                    <input type="checkbox" v-model="isShowWellId" />
                    <p>检查井编号</p>
                </li>
                <li class="amap-ui-ctrl-layer-base-item">
                    <input type="checkbox" v-model="isShowFlow"/>
                    <p>显示流向</p>
                </li>
            </ul>
            <div class="map-type-controls">
                <button :class="{ active: mapType === 'darkblue' }" @click="setMapType('darkblue')">平面</button>
                <button :class="{ active: mapType === '3d' }" @click="setMapType('3d')">3D图</button>
            </div>

        </div>

        <PipeDetail :detail="pipeDetail" v-if="pipeVisible" @changeVisible="pipeVisible = false" />
        <WellDetail :detail="wellDetail" v-if="wellVisible" @changeVisible="wellVisible = false" />
        <RainPipeDetail :detail="rainpipeDetail" v-if="rainpipeVisible" @changeVisible="rainpipeVisible = false" />
        <RainWellDetail :detail="rainwellDetail" v-if="rainwellVisible" @changeVisible="rainwellVisible = false" />
        <RainDrainDetail :detail="raindrainDetail" v-if="raindrainVisible" @changeVisible="raindrainVisible = false" />
        <area-facility-modal :visible="areaFacilityListVisible" :idList="areaFacilityIdList" @close="areaFacilityListVisible = false" />
        <LiquidDetail v-if="liquidVisible" :detail="liquidDetail" @changeVisible="liquidVisible = false" />
        <FlowmeterDetail v-if="flowVisible" :detail="flowDetail" @changeVisible="flowVisible = false" />
        <WaterQualityDetail v-if="waterQualityVisible" :detail="waterQualityDetail" @changeVisible="waterQualityVisible = false" />
        <MonitorDetail v-if="monitorVisible" :detail="monitorDetail" @changeVisible="monitorVisible = false" />
        <RainfallDetail v-if="rainfallVisible" :detail="rainfallDetail" @changeVisible="rainfallVisible = false" />
        <intercepting-well-detail :detail="cutoDetail" v-if="cutoVisible" @changeVisible="(payload) => (cutoVisible = payload)" />

    </div>
</template>
<style lang="less" scoped>
#map {
  position: fixed;
  top: -50px;
  left: 0;
  right: 0;
  bottom: -20px;
  z-index: 10;
}

.zoom-tip {
  position: fixed;
  z-index: 100;
  color: grey;
}

::v-deep .amap-ctrl-icon-layer,
::v-deep .amap-ctrl-list-layer {
  background-color: #091027;
  border-radius: 3px;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, .2);
  border: 1px solid #065645;
  color: #d7d7d7;
  z-index: 20;
}

::v-deep .amap-ctrl-base-layer {
  border-bottom: 1px solid #065645;
}
.map-type-controls {
  z-index: 1000;
  display: flex;
  justify-content: space-between;


  button {
    font-size: 0.8rem;
    width: 50%;
    padding: 4px 0;
    background-color: #091027;
    border: none;
    color: #d7d7d7;
    cursor: pointer;

    &.active {
      background-color: #065645;
    }
  }
}
</style>
<script>

import area from "@/mixins/area";
import Selector from "./components/selector.vue";
import ToolBar from "./components/tool-bar.vue";
import sewageScope from "./mixins/sewage-scope";
import sewagePipe from "./mixins/sewage-pipe";
import sewageWell from "./mixins/sewage-well";
import facility from "./mixins/facility";
import PipeDetail from "./components/pipe-detail.vue";
import WellDetail from "@/components/check-well/index.vue";
import rainPipe from "./mixins/rain-pipe";
import rainWell from "./mixins/rain-well";
import rainDrain from "./mixins/rain-drain";
import pumpPipe from "./mixins/pump-pipe";
import RainPipeDetail from "./components/rain-pipe-detail";
import RainWellDetail from "@/components/check-well/rain.vue";
import RainDrainDetail from "./components/rain-drain-detail";
import { Scene } from "@antv/l7";
import { GaodeMapV2 } from "@antv/l7-maps";
import { debounce } from "lodash";
import sourceMixin from "./mixins/source";
import connectMixin from "./mixins/connect";
import AreaFacilityModal from "./components/area-facility-modal.vue";
import { mapActions } from "vuex";
import AreaWindow from "./components/area-window.vue";
import { getCenterPoint, getAngle } from "@/utils/map";

export default {
    components: {
        Selector,
        ToolBar,
        PipeDetail,
        WellDetail,
        RainPipeDetail,
        RainWellDetail,
        RainDrainDetail,
        AreaFacilityModal,
        AreaWindow,
    },
    mixins: [
        area,
        sewagePipe,
        sewageWell,
        sewageScope,
        rainPipe,
        rainWell,
        rainDrain,
        pumpPipe,
        sourceMixin,
        connectMixin,
        facility,
    ],
    computed: {
        toolBarStyle() {
            if (this.isSidebarCollapsed) {
                return { top: '11vh', left: '5vw', };
            } else {
                return { top: '11vh', left: '335px', };
            }
        },
        toolBarStyle1() {
            if (this.isSidebarCollapsed) {
                return { bottom: '40px', left: '5vw', };
            } else {
                return { bottom: '40px', left: '335px', };
            }
        },
    },
    data() {
        return {
            selected: [],
            pathForAcross: null,
            areaFacilityIdList: [],
            areaFacilityListVisible: false,
            areaVisible: false,
            overlays: [],
            mouseTool: null,
            currentZoom: 14,
            isSidebarCollapsed: false,
            mapType: '3d',
            isShowFlow:false
        };
    },
    watch: {
        selected: {
            handler() {
                this.getpumpwell();
                if (this.selected.indexOf("污水管网") > -1) {
                    this.getPipe();
                } else {
                    this.removePipe();
                }

                if (this.selected.indexOf("污水检查井") > -1) {
                    this.getWell();
                } else {
                    this.removeWell();
                }

                if (this.selected.indexOf("污水收集区") > -1) {
                    this.getsewageScope();
                } else {
                    this.removesewageScope();
                }

                if (this.selected.indexOf("雨水管网") > -1) {
                    this.getrainpipe();
                } else {
                    this.removerainpipe();
                }
                if (this.selected.indexOf("雨水排口") > -1) {
                    this.getraindrain();
                } else {
                    this.removeraindrain();
                }

                if (this.selected.indexOf("雨水检查井") > -1) {
                    this.getrainwell();
                } else {
                    this.removerainwell();
                }

                if (this.selected.indexOf("截流设施") > -1) {
                    this.getCuto();
                } else {
                    this.removeCuto();
                }

                if (this.selected.indexOf("液位计") > -1) {
                    this.getLiquid();
                } else {
                    this.removeLiquid();
                }

                if (this.selected.indexOf("流量计") > -1) {
                    this.getFlow();
                } else {
                    this.removeFlow();
                }

                if (this.selected.indexOf("雨量计") > -1) {
                    this.getRainfall();
                } else {
                    this.removeRainfall();
                }

                if (this.selected.indexOf("水质监测站") > -1) {
                    this.getWaterQuality();
                } else {
                    this.removeWaterQuality();
                }

                if (this.selected.indexOf("视频监控") > -1) {
                    this.getMonitor();
                } else {
                    this.removeMonitor();
                }

                if (this.selected.indexOf("泵站信息") > -1) {
                    this.getpumpwell();
                } else {
                    this.removePump();
                }
            },
            deep: true,
        },
        selectedWellType() {
            this.wellList?.forEach((item) => {
                if (this.selectedWellType.find((type) => type === item.type)) {
                    item.layer.show();
                } else {
                    item.layer.hide();
                }
            });
        },
        selectedrainwellType() {
            this.rainwellList?.forEach((item) => {
                if (this.selectedrainwellType.find((type) => type === item.type)) {
                    item.layer.show();
                } else {
                    item.layer.hide();
                }
            });
        },
        isShowFlow(newVal) {
            console.log("isShowFlow::::", newVal);
            if (this.selected.indexOf("雨水管网") > -1) {
                this.getrainpipe();
                this.getPipe();
            }
        }
    },
    mounted() {
        this.debounceZoomChange = debounce(this.onZoomChange, 150);
        this.debounceMoveend = debounce(this.onMoveEnd, 150);
        const map = this.initMap();
        this.scene = new Scene({
            id: "map",
            logoVisible: false,
            map: new GaodeMapV2({
                mapInstance: map,
            }),
        });
        this.scene.on("loaded", () => {
            this.getFacilityList();
            this.setMapType("3d");
        });
        this.scene?.addImage("sewageWell", "/icon/sewage-well-active.png");
        this.scene?.addImage("rainWell", "/icon/rain-well-active.png");
        this.scene?.addImage("raindrain", "/icon/rain-outlet-active.png");
        this.scene?.addImage("cutoffwell", "/icon/intercepting-well-active.png");
        this.scene?.addImage("video", "/icon/monitor-active.png");
        this.scene?.addImage("liquidLevel", "/icon/liquid-active.png");
        this.scene?.addImage("flowMeter", "/icon/flow-active.png");
        this.scene?.addImage("rainFall", "/icon/rain-active.png");
        this.scene?.addImage("water-quality", "/icon/water-quality-active.png");
        this.scene?.addImage("selected", "/icon/selected.png");
        this.scene?.addImage("pump", "/icon/pump.png");
        this.selected = ["污水收集区","污水管网","污水检查井","雨水管网","雨水排口","雨水检查井",
                         "截流设施","流量计","液位计","雨量计","水质监测站","视频监控","泵站",];
    },
    beforeDestroy() {
        if (this.wellList?.length > 0) {
            this.wellList.forEach((item) => {
                item.layer.destroy();
                item.markers.forEach((marker) => {
                    marker.off("click", this.onWellClick);
                    marker.remove();
                });
            });
        }
        if (this.drainList?.length > 0) {
            this.drainList.forEach((item) => {
                item.off("click", this.onDrainClick);
                item.remove();
            });
            this.drainLabelsLayer?.destroy();
        }
        this.pipeLayer?.destroy();
        this.pipeLayer2?.destroy();
        this.activePipeLayer?.destroy();
        this.rainpipeLayer?.destroy();
        this.rainpipeLayer2?.destroy();
        this.activerainpipeLayer?.destroy();
        if (this.collectList?.length > 0) {
            this.collectList.forEach((item) => {
                item.off("click", this.onCollectMarkerClick);
                item.destroy();
            });
        }

        if (this.collectInfoWindow) {
            const tag = document.getElementById("collect-info-window-tag");
            const extra = document.getElementById("collect-info-window-extra");
            if (tag && extra) {
                console.log("bind event");
                tag.removeEventListener("click", this.openCollectDetail);
                extra.removeEventListener("click", this.closeCollectWindow);
            }
        }

        if (this.pumpInfoWindow) {
            const tag = document.getElementById("pump-info-window-tag");
            const video = document.getElementById("pump-info-window-video");
            const extra = document.getElementById("pump-info-window-extra");
            if (tag && extra) {
                console.log("bind event");
                tag.removeEventListener("click", this.openPumpDetail);
                video.removeEventListener("click", this.openPumpVideo);
                extra.removeEventListener("click", this.closePumpWindow);
            }
        }

        this.map.off("click", this.onMapClick);
        this.map?.off("zoomend", this.debounceZoomChange);
        this.map?.off("moveend", this.debounceMoveend);

        this.map?.clearMap();
        this.map?.destroy();
        this.scene?.destroy();
    },
    methods: {
        ...mapActions("home", ["getFacilityList"]),
        handleSidebarToggle(isCollapsed) {
            this.isSidebarCollapsed = isCollapsed;
        },
        initMap() {
            const { AMap } = window;
            if (!AMap) {
                return;
            }
            var map = new AMap.Map("map", {
                viewMode: "3D",
                terrain: true,
                pitch: 52,
                center: [118.536766,32.993047],
                zoom: 14,
                mapStyle: "amap://styles/satellite",
                WebGLParams: {
                    preserveDrawingBuffer: true,
                },
            });
            const that = this;

            AMap.plugin(
                [
                    "AMap.Scale",
                    "AMap.HawkEye",
                    "AMap.MapType",
                    "AMap.PolygonEditor",
                    "AMap.MouseTool",
                    "AMap.TileLayer.Satellite"
                ],
                function () {
                    map.addControl(new AMap.Scale());
                    map.addControl(new AMap.HawkEye({ isOpen: true, mapStyle: "amap://styles/satellite", }));
                    map.addControl(new AMap.MapType());
                    that.satelliteLayer = new AMap.TileLayer.Satellite({
                        zIndex: 1
                    });
                    that.mouseTool = new AMap.MouseTool(map);
                    that.overlays = [];
                    that.mouseTool.on("draw", function (e) {
                        that.overlays.push(e.obj);
                    });
                }
            );

            this.map = map;
            map.on("click", this.onMapClick);
            map.on("zoomend", this.debounceZoomChange);
            map.on("moveend", this.debounceMoveend);
            return map;
        },
        setMapType(type) {
            this.mapType = type;
            if (type === 'darkblue') {
                this.map.setMapStyle('amap://styles/light');
                this.map.setPitch(0);
            } else if (type === 'satellite') {
                this.map.setMapStyle('amap://styles/satellite');
                this.map.setPitch(0);
            } else if (type === '3d') {
                this.map.setMapStyle('amap://styles/satellite');
                this.map.setPitch(52);
            }
        },
        onMoveEnd() {
            if (this.currentZoom < 16.7) return;
            const center = this.map?.getCenter();
            let path = [
                [center.lng + 0.01, center.lat + 0.01],
                [center.lng + 0.01, center.lat - 0.01],
                [center.lng - 0.01, center.lat + 0.01],
                [center.lng - 0.01, center.lat - 0.01],
            ];
            const { AMap } = window;

            this.clearPipeText();

            this.sewagePipeTextList = [];

            if (this.selected.indexOf("污水管网") > -1) {
                for (let i = 0; i < this.sewagePipeRawList.length; i++) {
                    const item = this.sewagePipeRawList[i];
                    if (!item[5]) {
                        continue;
                    }

                    const flag =
                        AMap.GeometryUtil.isPointInRing(
                            [parseFloat(item[1]), parseFloat(item[2])],
                            path
                        ) ||
                        AMap.GeometryUtil.isPointInRing(
                            [parseFloat(item[3]), parseFloat(item[4])],
                            path
                        );
                    if (!flag) {
                        continue;
                    }
                    const point = getCenterPoint(
                        item[1] + "," + item[2],
                        item[3] + "," + item[4]
                    );
                    if (!point.lng) {
                        continue;
                    }

                    const angleValue = getAngle(
                        parseFloat(item[1]),
                        parseFloat(item[2]),
                        parseFloat(item[3]),
                        parseFloat(item[4])
                    );

                    const text = new AMap.Text({
                        text: item[6] + "/DN" + item[5],
                        zIndex: 500,
                        zooms: [18, 20],
                        anchor: "center", // 设置文本标记锚点
                        angle: angleValue,
                        offset: [16, 16],
                        style: {
                            "text-align": "center",
                            "font-size": "8px",
                            color: "#e89915",
                            background: "transparent",
                            "border-width": 0,
                        },
                        position: [point.lng, point.lat],
                    });
                    this.sewagePipeTextList.push(text);
                }
            }

            if (this.sewagePipeTextList.length > 0) {
                this.map.add(this.sewagePipeTextList);
            }

            this.rainPipeTextList = [];

            if (this.selected.indexOf("雨水管网") > -1) {
                for (let i = 0; i < this.rainPipeRawList.length; i++) {
                    const item = this.rainPipeRawList[i];
                    const flag =
                        AMap.GeometryUtil.isPointInRing(
                            [parseFloat(item[1]), parseFloat(item[2])],
                            path
                        ) ||
                        AMap.GeometryUtil.isPointInRing(
                            [parseFloat(item[3]), parseFloat(item[4])],
                            path
                        );
                    if (!flag) {
                        continue;
                    }

                    const point = getCenterPoint(
                        item[1] + "," + item[2],
                        item[3] + "," + item[4]
                    );
                    if (!point.lng) {
                        continue;
                    }

                    const angleValue = getAngle(
                        parseFloat(item[1]),
                        parseFloat(item[2]),
                        parseFloat(item[3]),
                        parseFloat(item[4])
                    );

                    const text = new AMap.Text({
                        text: item[6] + "/DN" + item[5],
                        zIndex: 500,
                        zooms: [18, 20],

                        anchor: "center", // 设置文本标记锚点
                        angle: angleValue,
                        offset: [16, 16],
                        style: {
                            "text-align": "center",
                            "font-size": "8px",
                            color: "#2789ff",
                            background: "transparent",
                            "border-width": 0,
                        },
                        position: [point.lng, point.lat],
                    });
                    this.rainPipeTextList.push(text);
                }
            }

            if (this.rainPipeTextList.length > 0) {
                this.map.add(this.rainPipeTextList);
            }
        },
        clearPipeText(type) {
            if (type === "sewage") {
                if (this.sewagePipeTextList && this.sewagePipeTextList.length > 0) {
                    this.map.remove(this.sewagePipeTextList);
                }
            } else if (type === "rain") {
                if (this.rainPipeTextList && this.rainPipeTextList.length > 0) {
                    this.map.remove(this.rainPipeTextList);
                }
            } else {
                if (this.sewagePipeTextList && this.sewagePipeTextList.length > 0) {
                    this.map.remove(this.sewagePipeTextList);
                }
                if (this.rainPipeTextList && this.rainPipeTextList.length > 0) {
                    this.map.remove(this.rainPipeTextList);
                }
            }
        },
        onZoomChange() {
            this.changeSewageScopeSize();

            const zoom = this.map?.getZoom() || 3;
            this.currentZoom = zoom;


            // if (zoom >= 16.7) {
            //     this.onMoveEnd();
            //     this.map.setFeatures(["road", "building", "water", "land", "point", "label"]);
            // } else {
            //     this.clearPipeText();
            //     this.map.setFeatures(["road", "building", "water", "land"]);
            // }

            if (zoom >= 16.7) {
                this.getWell();
                this.getrainwell();
            } else {
                this.removeWell();
                this.removerainwell();
            }

            this.cutoLayer?.size(zoom * 0.55);
            this.liquidLayer?.size(zoom * 0.55);
            this.flowLayer?.size(zoom * 0.55);
            this.rainfallLayer?.size(zoom * 0.55);
            this.waterQualityLayer?.size(zoom * 0.55);
            this.monitorLayer?.size(zoom * 0.55);
            this.facilityActiveLayer?.size(zoom * 0.6);
            this.pumpLayer?.size(zoom * 0.55);
            this.sewageWellLayer?.size(zoom * 0.55);
            this.rainWellLayer?.size(zoom * 0.55);

            this.raindrainLayer?.size(zoom * 0.55);

            if (zoom >= 20) {
                this.pipeLayer?.size(3);
                this.pipeLayer2?.size(3);
                this.rainpipeLayer?.size(3);
                this.rainpipeLayer2?.size(3);

                this.map.setPitch(20, true);
            } else {
                this.pipeLayer?.size(1);
                this.pipeLayer2?.size(1);
                this.rainpipeLayer?.size(1);
                this.rainpipeLayer2?.size(1);

                this.map.setPitch(0, true);
            }

            if (this.mapType === "3d") {
                this.map.setPitch(52, true);
            } else {
                if (zoom >= 20) {
                    this.map.setPitch(20, true);
                } else {
                    this.map.setPitch(0, true);
                }
            }
        },
        onMapClick(e) {
            const { AMap } = window;
            if (this.controlType === "across") {
                const lng = e.lnglat.getLng();
                const lat = e.lnglat.getLat();

                if (!this.markerForAcross1) {
                    this.markerForAcross1 = new AMap.Marker({
                        position: new AMap.LngLat(lng, lat),
                    });

                    this.map.add(this.markerForAcross1);
                    this.$message.info("请点击管线另一侧");
                    return;
                }
                if (!this.markerForAcross2) {
                    this.markerForAcross2 = new AMap.Marker({
                        position: new AMap.LngLat(lng, lat),
                    });

                    this.map.add(this.markerForAcross2);

                    this.pathForAcross = [
                        this.markerForAcross1.getPosition(),
                        this.markerForAcross2.getPosition(),
                    ];

                    this.polylineForAcross = new AMap.Polyline({
                        path: this.pathForAcross,
                        borderWeight: 2,
                        strokeColor: "red",
                        lineJoin: "round",
                    });

                    this.map.add(this.polylineForAcross);
                }
            }
        },
        onChange(payload) {
            this.selected = payload;
        },
        cancel() {
            this.areaVisible = false;
            this.mouseTool.close(true);
            this.map?.remove(this.overlays);
            this.overlays = [];
        },
        clear() {
            this.map?.remove(this.overlays);
            this.overlays = [];
        },
        query(list) {
            const AMap = window.AMap;
            const idList = [];

            list.forEach((position) => {
                if (this.sewagePipeRawList?.length > 0) {
                    this.sewagePipeRawList.forEach((item) => {
                        const startPosition = [parseFloat(item[1]), parseFloat(item[2])];
                        const endPosition = [parseFloat(item[3]), parseFloat(item[4])];

                        if (
                            AMap.GeometryUtil.isPointInRing(startPosition, position) &&
                            AMap.GeometryUtil.isPointInRing(endPosition, position)
                        ) {
                            idList.push({
                                id: item[0],
                                type: "sewage",
                            });
                        }
                    });
                }
                if (this.rainPipeRawList?.length > 0) {
                    this.rainPipeRawList.forEach((item) => {
                        const startLng = parseFloat(item[1]);
                        const startLat = parseFloat(item[2]);
                        const endLng = parseFloat(item[3]);
                        const endLat = parseFloat(item[4]);
                        if (isNaN(startLng)) return;
                        if (isNaN(startLat)) return;
                        if (isNaN(endLng)) return;
                        if (isNaN(endLat)) return;

                        const startPosition = [parseFloat(item[1]), parseFloat(item[2])];
                        const endPosition = [parseFloat(item[3]), parseFloat(item[4])];

                        if (
                            AMap.GeometryUtil.isPointInRing(startPosition, position) &&
                            AMap.GeometryUtil.isPointInRing(endPosition, position)
                        ) {
                            idList.push({
                                id: item[0],
                                type: "rain",
                            });
                        }
                    });


                if (this.sewageWellRawList?.length > 0) {
                    this.sewageWellRawList.forEach((item) => {
                        const lng = parseFloat(item[3]);
                        const lat = parseFloat(item[4]);
                        if (isNaN(lng)) return;
                        if (isNaN(lat)) return;

                        const location = [lng, lat];

                        if (AMap.GeometryUtil.isPointInRing(location, position)) {
                            idList.push({
                                id: item[0],
                                type: "rain-well",
                            });
                        }
                    });
                }
            }

            if (this.facilityList?.length > 0) {
                this.facilityList.forEach((item) => {
                    const location = [item.x, item.y];

                    if (AMap.GeometryUtil.isPointInRing(location, position)) {
                        idList.push({
                            id: item.id,
                            type: "facility",
                        });
                    }
                });
            }
        });

        if (idList.length > 0) {
            this.areaFacilityIdList = Object.freeze(Array.from(new Set(idList)));
            this.areaFacilityListVisible = true;
        } else {
            this.$message.error("选择范围内没有设施");
        }
        },
},
};
</script>